import { Routes } from "@angular/router";
import { maintenanceGuard } from "../../shared/guards/auth-guard.guard";

export const accountRecoveryRoutes: Routes = [
    {
        path: 'account-recovery',
        title: 'Account recovery',
        loadComponent: () => import('./account-recovery.component').then(m => m.AccountRecoveryComponent),
        canActivate: [maintenanceGuard],
        canActivateChild: [maintenanceGuard],
        children: [
            {
                path: 'new-ecommerce',
                title: 'Welcome to Our New e-Commerce',
                loadComponent: () => import('./new-ecommerce-experience/new-ecommerce-experience.component').then(m => m.NewEcommerceExperienceComponent)
            },
            {
                path: 'check-email',
                title: 'Check email',
                loadComponent: () => import('./check-email/check-email.component').then(m => m.CheckEmailComponent)
            },
            {
                path: 'check-code',
                title: 'Check code',
                loadComponent: () => import('./check-code/check-code.component').then(m => m.CheckCodeComponent)
            },
            {
                path: 'new-password',
                title: 'New password',
                loadComponent: () => import('./new-password/new-password.component').then(m => m.NewPasswordComponent)
            },
            {
                path: 'password-restored',
                title: 'Password restored',
                loadComponent: () => import('./password-restored/password-restored.component').then(m => m.PasswordRestoredComponent)
            },
        ]
    }
]
